jQuery( document ).ready(function() {

    if($('.partnerslist').length > 0) {
        $(".partnerslist_item").each(function() {
            var count = $(this).find(".partnerslist_content").text().length;
            if (count < 315) {
                $(this).find(".partnerslist_showplus").remove();
            }
        });

        $(".partnerslist_showplus").click(function(){
            $(this).toggleClass("up");
            $(this).parent().find(".partnerslist_content").toggleClass("height_auto");
        });
    }
});